/* Adds "Shop" to the v5 top nav of the ported pages (David, 2026-10-14), right before FAQ. */
export function addShopLink(root: HTMLElement) {
  const links = root.querySelector('#nav .links');
  if (!links || links.querySelector('a[href="/shop"]')) return;
  const a = document.createElement('a');
  a.href = '/shop';
  a.textContent = 'Shop';
  const faq = Array.from(links.querySelectorAll('a')).find((x) => /faq$/i.test(x.getAttribute('href') || ''));
  links.insertBefore(a, faq || null);
}
